import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { Maybe } from 'types/UtilityTypes';
import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

export type RefNumQualifier = {
  ID: number;
  CreatedAt: string;
  UpdatedAt: string;
  DeletedAt: Maybe<string>;
  tmsIntegrationId: number;
  qualifierId: number;
  label: string;
  value: string;
  flag: string;
};

export type GetRefNumQualifiersResponse = {
  qualifiers: RefNumQualifier[];
};

export async function getRefNumQualifiers(
  tmsID: number
): Promise<Result<GetRefNumQualifiersResponse, ApiError>> {
  try {
    const response = await axios.get<GetRefNumQualifiersResponse>(
      `/ref-num-qualifiers?tmsID=${tmsID}`
    );
    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'getRefNumQualifiers' });

    if (!isAxiosError(error)) {
      return err({ message: 'Failed to get reference number qualifiers' });
    }

    if (error && error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message:
        error.response?.data.message ||
        'Failed to get reference number qualifiers',
    });
  }
}
